import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const holidayStressToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.HOLIDAY_STRESS,
  iFrameSrcUrl: '/holidaystress',
  micrositeUrl: 'holidaystress',
  title: {
    id: 'holidaystress.title',
    defaultMessage: 'Your holiday well-being toolkit',
    description: 'Microsite page title',
  },
  featureFlag: 'isHolidayStressToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/managing-mental-health-at-the-holidays',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION },
  ],
  page: '202611 holidaystress',
  trackUTMParams: {
    utm_campaign: 'Nov1126',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'Holiday Stress',
  },
  shouldHideForInternational: false,
}
